import { useTranslation } from 'react-i18next';
import { FormItem } from '../../../../components/FormItem';
import { FormItemName } from '../../../../lib/models/Form';
import { FormInput } from '../../../../components/FormInput';
import { ReactComponent as LinkIcon } from './../../../../assets/icons/link-icon-gray.svg';
import styles from './index.module.scss';

const agb = 'unique.formItems.agb';

const url = 'unique.formItems.url';

export const AGBFormItem = () => {
  const { t } = useTranslation();

  return (
    <FormItem
      name={FormItemName.AGB}
      hasFeedback={true}
      rules={[
        {
          required: false,
        },
        {
          type: 'url',
          message: t(`${url}.errors.invalid`),
        },
        { max: 200 },
      ]}
    >
      <FormInput icon={<LinkIcon />} className={styles.inputUrl} label={t(`${agb}.label`)} />
    </FormItem>
  );
};
